import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import TransactionRow from 'modules/common/components/TransactionRow';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';
import BuildingMaterialModal from '../modals/BuildingMaterialModal';

function BuildingMaterialContent({
  handleAddMaterialTypeModal,
  handleEditMaterialTypeModal,
  handleRemoveMaterialTypeModal,
  materialTypeId,
  getSingleMaterialType,
  materialTypeInfo,
  removeBuildingMaterial,
  getBuildingMaterialTypeList,
  materialTypesList,
  history,
}) {
  useEffect(() => {
    if (_.isEmpty(materialTypeId)) return;
    getSingleMaterialType(materialTypeId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(materialTypeId)) return;
    getSingleMaterialType(materialTypeId);
  }, [materialTypeId]);

  const setModal = useContext(ModalContext);

  const building_material = _.get(materialTypeInfo, 'attributes.materials')

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <BuildingMaterialModal materialTypeId={materialTypeId} type="NEW" />,
      title: 'Add Building Material',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <BuildingMaterialModal type="EDIT" materialTypeId={materialTypeId} updateList={data} id={data.id} />,
      title: 'Update Building Material',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this building material?',
      () => {
        removeBuildingMaterial(materialTypeId, data.id, () => {
          getBuildingMaterialTypeList();
          const id = _.get(materialTypesList, '0.id');
          history.push(`${id}`);
          getSingleMaterialType(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <>
      <div className="row mb-3">
        <div className="ml-auto">
          <button
            type="button"
            onClick={handleAddMaterialTypeModal}
            className="btn btn-building-material font-weight-bold"
          >
            <i className="fas fa-plus" /> Add Building Material Type
          </button>
        </div>
      </div>
      <div className="ml-3 card right-section">
        <div className="p-3">
          <div className="d-flex mb-3">
            <div className="col-8 mt-2">
              <span className="font-weight-bold"> Information </span>
            </div>
            <div className="col-4 d-flex">
              <div className="ml-auto">
                <button
                  type="button"
                  className="btn-blank"
                  onClick={handleEditMaterialTypeModal(materialTypeInfo)}
                >
                  <i className="far fa-edit icon-edit" />
                </button>
                <button
                  type="button"
                  className="btn-blank"
                  onClick={handleRemoveMaterialTypeModal(materialTypeInfo)}
                >
                  <i className="far fa-trash-alt icon-delete" />
                </button>
              </div>
            </div>
          </div>
          <hr />
          {!_.isEmpty(materialTypeInfo) ? (
            <React.Fragment>
              <div className="row px-3 mt-3">
                <div className="col-12">
                  <table className="transaction-table table table-borderless table-sm table-striped">
                    <tbody>
                      <TransactionRow
                        title="Name"
                        value={_.get(materialTypeInfo, 'attributes.name') || '--'}
                      />
                      <TransactionRow
                        title="Description"
                        value={_.get(materialTypeInfo, 'attributes.description') || '--'}
                      />
                      <TransactionRow
                        title="Is Active"
                        value={
                          _.get(materialTypeInfo, 'attributes.is_active') === 1
                            ? 'YES'
                            : 'NO'
                            || '--'}
                      />
                    </tbody>
                  </table>
                </div>
              </div>
            </React.Fragment>
          ) : (
            <div className="d-flex align-items-center justitfy-content-center h-100">
              <div className="text-center mx-auto py-4">
                <img
                  src={emptyStateImage}
                  className="img-responsive image-wrapper mb-4 mt-3"
                  alt="Empty State"
                />
                <p className="emp-title mb-0"> No Item Found </p>
              </div>
            </div>
          )}
          <div className="mt-2 ml-3">
            <div className="row d-flex justify-content-center w-100">
              <div className="mt-1">
                <div className="row mb-3 d-flex align-items-center">
                  <div className="col py-0">
                    <h3 className="m-0 text-color font-weight-bold">Building Material</h3>
                  </div>
                  <div className="row py-0 m-0 d-flex mr-3">
                    <button
                      type="button"
                      onClick={handleAddModal}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4 mr-2 ml-auto"
                    >
                      <i className="fas fa-plus" /> Add Building Material
                    </button>
                  </div>
                </div>
                <div className="row my-3 mx-0">
                  <table className="css-table table table-sm table-striped table-hover">
                    <thead className="table-header">
                      <tr>
                        <td width="200"><b>Name</b></td>
                        <td width="200"><b>Description</b></td>
                        <td style={{ textAlign: 'center' }} width="200"><span className="font-weight-bold" style={{ marginLeft: 100 }}>Actions</span></td>
                      </tr>
                    </thead>
                    <tbody>
                      {building_material && building_material.length ? (
                        building_material.map((item) => {
                          return (
                            <tr key={item.id}>
                              <td className="history-color">{item.name}</td>
                              <td className="history-color">{item.description}</td>
                              <td style={{ textAlign: 'right' }}>
                                <button
                                  type="button"
                                  className="btn-blank"
                                  onClick={handleEdit(item)}
                                >
                                  <i className="far fa-edit icon-edit" />
                                </button>
                                <button
                                  type="button"
                                  className="btn-blank"
                                  onClick={handleRemove(item)}
                                >
                                  <i className="far fa-trash-alt icon-delete" />
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td />
                          <td>No Data</td>
                          <td />
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

BuildingMaterialContent.propTypes = {
  removeBuildingMaterial: PropTypes.instanceOf(Function).isRequired,
  getBuildingMaterialTypeList: PropTypes.instanceOf(Function).isRequired,
  materialTypesList: PropTypes.instanceOf(Array).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  handleAddMaterialTypeModal: PropTypes.instanceOf(Function).isRequired,
  handleEditMaterialTypeModal: PropTypes.instanceOf(Function).isRequired,
  handleRemoveMaterialTypeModal: PropTypes.instanceOf(Function).isRequired,
  getSingleMaterialType: PropTypes.instanceOf(Function).isRequired,
  materialTypeInfo: PropTypes.instanceOf(Object).isRequired,
  materialTypeId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  materialTypeInfo: _.get(api, `${c.GET_SINGLE_BUILDING_MATERIAL_TYPE}.item`) || {},
  materialTypesList: _.get(api, `${c.GET_BUILDING_MATERIAL_TYPE}.list`) || [],
  materialTypeId: _.get(match, 'params.materialTypeId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BuildingMaterialContent);
